import { get } from "@insite/client-framework/Services/ApiService";
import { AdditionalSettingsModel } from "@tLinc/Store/Reducer/AdditionalSettingsReducer";

export function getAdditionalSettings() {
    const apiUrl = `/api/v1/additionalsettings`;
    return get<AdditionalSettingsModel>(`${apiUrl}`);
}
